module.exports = __webpack_public_path__ + "static/media/menu-card-3.e6d045a0.jpg";